<template>
	<modal v-model="loadoutManagerState" modal-class="lm-modal">
		<template #header>
			<span>TAP TO SWAP</span>
		</template>
		<template #body>
			<loadout-manager minimized edit />
		</template>
	</modal>
</template>

<script>
import Modal								from '@/components/UI/Modal';
import LoadoutManager				from '@/components/LoadoutManager';

import { openManager }			from '@/utils/LoadoutList';

export default {
	components: {
		Modal,
		LoadoutManager
	},
	computed: {
		loadoutManagerState: {
			get() {
				return openManager.value;
			},
			set(value) {
				openManager.value = value;
			}
		}
	}
};
</script>

<style lang="scss">
.modal-content.lm-modal {
	width: 400px;
}
</style>
